
import { defineComponent, ref, reactive, onMounted, computed, inject, watch } from "vue"
import { useStore } from "vuex";

//service
import personService from "@/core/services/PersonService"
import { errManager, showMessage } from "@/core/config/Tools";

import type { FormInstance, FormRules } from "element-plus";

export default defineComponent({
    name: "sPerson",
    props: {
        idperson: {
            type: String,
            required: true,
            default: ""
        }
    },
    components: {
        //btnDownload
    },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const store = useStore();
        const loader = ref(false)
        const formPersonRef = ref<FormInstance>()
        const gblPersona = inject<any>('gblPersona')
        const formPerson = reactive(<any>{
            doctype: null,
            phone2: null
        })
        const rules = reactive<FormRules>({
            doctype: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            docnumber: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            firstname: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            lastname: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            surname: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            gender: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            birthday: [{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur", "change"],
            }],
            iddistrict: [{
                required: false,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            address: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            country: [{
                required: true,
                message: 'campo requerido',
                trigger: ['blur', 'change'],
            }],
            phone1: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            email1: [{
                required: true,
                message: 'campo requerido',
                trigger: ["blur", "change"],
            },
            {
                type: 'email',
                message: 'Ingrese un email válido',
                trigger: ["blur", "change"],
            },],
            email2: [{
                required: false,
                message: 'campo requerido',
                trigger: ["blur", "change"],
            },
            {
                type: 'email',
                message: 'Ingrese un email válido',
                trigger: ["blur", "change"],
            },]
        })

        //const gblPhoto = inject<any>('gblPhoto') 
        //const gblDataPhoto = inject<any>('gblDataPhoto')
        //const dialogPhoto = inject<any>('dialogPhoto')

        const getDocuments: any = computed<any>(() => {
            return store.getters.currentUser.type_documents;
        })

        const getGender: any = computed<any>(() => {
            return store.getters.currentUser.gender;
        })

        const getUbigeo: any = computed<any>(() => {
            return store.getters.currentUser.ubigeo;
        })

        const listCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        });

        const getPerson = async () => {
            loader.value = true
            await personService.get(props.idperson)
                .then((res) => {
                    loader.value = false
                    if (res.data)
                        Object.assign(formPerson, res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    (props.idperson) ? savePerson() : savePerson2()
                }

            });
        };

        const savePerson = async () => {
            loader.value = true
            await personService.update(props.idperson, formPerson)
                .then((res) => {
                    Object.assign(gblPersona.value, formPerson)
                    loader.value = false
                    showMessage(res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const savePerson2 = async () => {
            loader.value = true
            await personService.save(formPerson)
                .then((res) => {
                    loader.value = false
                    if (res.data.status == 'success')
                        emit("onResponse", res.data)
                    showMessage(res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }


        //const openDialogPhoto = () => {
        //gblDataPhoto.value = {
        //    target: 'photo',
        //    id: props.idperson
        //}
        //dialogPhoto.value = true
        //}

        //watch(() => gblPhoto.value, getPhoto);

        onMounted(() => {
            if (props.idperson)
                getPerson()
        })

        return {
            loader,
            //loaderPhoto,
            //dialogPhoto,
            formPersonRef,
            formPerson,
            listCountry,
            rules,
            getDocuments,
            getGender,
            getUbigeo,
            //events
            submitForm,
            savePerson, savePerson2
            //openDialogPhoto,
            //gblPhoto,
            //gblDataPhoto
        }
    },
})
